
<div
  v-if="activeSlider"
  class="rfp-rr-title-section-177-or review-popup-overlay"
  style="display: block; overflow: auto"
>
  <div
    v-if="showWriteReviewPopup"
    class="rfp-rr-ratings-write-review-178-or review-popup"
    :class="{ 'rfp-rr-rating-rtl': isRightToLeftActive }"
    style="display: block"
  >
    <div
      class="rfp-rr-ratings-write-review-179-or review-popup-close"
      :class="{ 'rfp-rr-rating-rtl-left': isRightToLeftActive }"
      @click="closePopup('yes')"
    >
      X
    </div>
    <form
      id="formId"
      class="rfp-rr-ratings-write-review-180-or"
      method="post"
      novalidate=""
      @submit.prevent="submit"
    >
      <div class="rfp-rr-ratings-write-review-181-or popup-inner">
        <div class="rfp-rr-ratings-write-review-182-or review-popup-header">
          <label v-html="headerTitle"></label>
        </div>
        <div class="rfp-rr-ratings-write-review-183-or review-popup-body">
          <div
            v-if="userText != ''"
            class="rfp-rr-ratings-write-review-241-or body-row full-width"
            :class="{ 'rfp-rr-rating-rtl': isRightToLeftActive }"
            v-html="userText"
          ></div>
          <div
            class="rfp-rr-ratings-write-review-184-or body-row overall-rating"
            :class="{ 'label-hide-show': !showLabelOverallRating }"
          >
            <div
              class="rfp-rr-ratings-write-review-185-or body-row-left"
              :class="{ 'rfp-rr-rating-rtl-float-right': isRightToLeftActive }"
            >
              {{ labelOverallRating }}
            </div>
            <div
              class="rfp-rr-ratings-write-review-186-or body-row-right"
              :class="{ 'rfp-rr-rating-rtl-float-right': isRightToLeftActive }"
            >
              <div class="rfp-rr-ratings-write-review-187-or stars">
                <div class="rfp-rr-ratings-write-review-188-or star">
                  <vue-star-rating
                    :increment="starRatingIncrementValue"
                    :max-rating="starRatingMaxRatingValue"
                    :inactive-color="starRatingInactiveColor"
                    :active-color="starRatingActiveColor"
                    :star-size="starRatingStarSize"
                    :overall-rating="overallRating"
                    :show-rating="false"
                    :rating="overallRating"
                    @update:rating="overallRating = $event"
                  >
                  </vue-star-rating>
                </div>
              </div>
              <div
                class="rfp-rr-ratings-write-review-189-or star-label"
                :class="{ 'rfp-rr-rating-rtl-float-left': isRightToLeftActive }"
              >
                <div v-if="overallRating === 1">
                  {{ starRatingOverallRatingDesc.one }}
                </div>
                <div v-else-if="overallRating === 2">
                  {{ starRatingOverallRatingDesc.two }}
                </div>
                <div v-else-if="overallRating === 3">
                  {{ starRatingOverallRatingDesc.three }}
                </div>
                <div v-else-if="overallRating === 4">
                  {{ starRatingOverallRatingDesc.four }}
                </div>
                <div v-else-if="overallRating === 5">
                  {{ starRatingOverallRatingDesc.five }}
                </div>
                <div v-else>
                  {{ starRatingOverallRatingDefault }}
                </div>
              </div>
              <span
                v-if="validation.firstError('overallRating')"
                class="rfp-rr-ratings-write-review-190-or Refapp-ratings-validation-error rfp-ratings-specificAlignment"
              >
                {{ overallRatingFieldValidationMsg }}
              </span>
            </div>
          </div>
          <div
            class="rfp-rr-ratings-write-review-191-or body-row full-width"
            :class="{ 'label-hide-show': !showLabelReviewTitle }"
          >
            <div class="rfp-rr-ratings-write-review-192-or body-row-left">
              {{ labelReviewTitle }}
            </div>
            <div class="rfp-rr-ratings-write-review-193-or body-row-right">
              <input
                v-model="reviewTitle"
                type="text"
                :placeholder="reviewTitlePlaceholder"
                :maxlength="reviewTitleMaxLength"
                name="reviewTitle"
              />
              <span
                v-if="validation.firstError('reviewTitle')"
                class="rfp-rr-ratings-write-review-194-or Refapp-ratings-validation-error"
              >
                {{ reviewTitleFieldValidationMsg }}
              </span>
            </div>
          </div>
          <div
            class="rfp-rr-ratings-write-review-195-or body-row full-width"
            :class="{ 'label-hide-show': !showLabelReview }"
          >
            <div class="rfp-rr-ratings-write-review-196-or body-row-left">
              {{ labelReview }}
            </div>
            <div class="rfp-rr-ratings-write-review-197-or body-row-right">
              <textarea
                v-model="review"
                class="rfp-rr-ratings-write-review-198-or ratings-review-font"
                :placeholder="reviewPlaceholder"
                :maxlength="reviewMaxLength"
                name="review"
              ></textarea>
              <span
                v-if="validation.firstError('review')"
                class="rfp-rr-ratings-write-review-199-or Refapp-ratings-validation-error"
              >
                {{ reviewFieldValidationMsg }}
              </span>
            </div>
          </div>
          <div
            class="rfp-rr-ratings-write-review-200-or body-row recommend"
            :class="{
              'label-hide-show': !showLabelWouldYouRecommendProductToFriend,
            }"
          >
            <div class="rfp-rr-ratings-write-review-201-or body-row-left">
              {{ labelProductRecommend }}
            </div>
            <div class="rfp-rr-ratings-write-review-202-or body-row-right">
              <toggle
                v-model="WouldYouRecommendThisProductToFriend"
                class="rfp-rr-ratings-write-review-203-or toggle-colors"
              />
            </div>
          </div>
          <div
            class="rfp-rr-ratings-write-review-235-or body-row"
            :class="{ 'label-hide-show': !userTypeShowHide }"
          >
            <div class="rfp-rr-ratings-write-review-236-or body-col">
              <div class="rfp-rr-ratings-write-review-237-or rfp-user-type-label body-row-left">
                {{ userType }}
              </div>
            </div>
            <div class="rfp-rr-ratings-write-review-238-or body-col">
              <div class="rfp-rr-ratings-write-review-239-or body-row-right">
                <select
                  id="userType"
                  v-model="userTypes"
                  class="rfp-rr-ratings-write-review-240-or"
                  name="userType"
                >
                  <option value="">{{ dropDownSelectText }}</option>
                  <option v-for="x in userTypeDatas" :key="x" :value="x">{{ x }}</option>
                </select>
                <span
                  v-if="validation.firstError('userTypes')"
                  class="rfp-rr-ratings-write-review-194-or Refapp-ratings-validation-error"
                >
                  {{ userTypesFieldValidationMsg }}
                </span>
              </div>
            </div>
          </div>
          <div
            class="rfp-rr-ratings-write-review-204-or body-row"
            :class="{
              'label-hide-show': !showLabelLocation && !showLabelNickname,
            }"
          >
            <div
              class="rfp-rr-ratings-write-review-205-or"
              :class="{
                'label-hide-show': !showLabelNickname,
                ' body-col': showLabelLocation,
              }"
            >
              <div class="rfp-rr-ratings-write-review-206-or body-row-left">
                {{ labelNickname }}
              </div>
              <div class="rfp-rr-ratings-write-review-207-or body-row-right">
                <input
                  v-model="nickname"
                  :placeholder="nicknamePlaceholder"
                  :maxlength="nicknameMaxLength"
                  name="nickname"
                  type="text"
                />
                <span
                  v-if="validation.firstError('nickname')"
                  class="rfp-rr-ratings-write-review-208-or Refapp-ratings-validation-error"
                >
                  {{ nicknameFieldValidationMsg }}
                </span>
              </div>
            </div>
            <div
              class="rfp-rr-ratings-write-review-209-or"
              :class="{
                'label-hide-show': !showLabelLocation,
                ' body-col': showLabelNickname,
              }"
            >
              <div class="rfp-rr-ratings-write-review-210-or body-row-left">
                {{ labelLocation }}
              </div>
              <div class="rfp-rr-ratings-write-review-211-or body-row-right">
                <input
                  v-model="location"
                  :placeholder="locationPlaceholder"
                  :maxlength="locationMaxLength"
                  name="location"
                  type="text"
                />
                <span
                  v-if="validation.firstError('location')"
                  class="rfp-rr-ratings-write-review-212-or Refapp-ratings-validation-error"
                >
                  {{ locationFieldValidationMsg }}
                </span>
              </div>
            </div>
          </div>
          <div
            class="rfp-rr-ratings-write-review-213-or body-row"
            :class="{
              'label-hide-show': !showHowOldAreYou && !showLabelEmail,
            }"
          >
            <div
              class="rfp-rr-ratings-write-review-214-or"
              :class="{
                'label-hide-show': !showLabelEmail,
                'body-col': showHowOldAreYou,
              }"
            >
              <div class="rfp-rr-ratings-write-review-215-or body-row-left">
                {{ labelEmail }}
              </div>
              <div class="rfp-rr-ratings-write-review-216-or body-row-right">
                <input v-model="emailStatus" :placeholder="emailPlaceholder" type="text" />
                <span
                  v-if="validation.firstError('emailStatus')"
                  class="rfp-rr-ratings-write-review-217-or Refapp-ratings-validation-error"
                >
                  {{ emailFieldValidationMsg }}
                </span>
              </div>
            </div>
            <div
              class="rfp-rr-ratings-write-review-218-or"
              :class="{
                'label-hide-show': !showHowOldAreYou,
                'body-col': showLabelEmail,
              }"
            >
              <div class="rfp-rr-ratings-write-review-219-or body-row-left">
                {{ labelHowOldAreYou }}
              </div>
              <div class="rfp-rr-ratings-write-review-220-or body-row-right">
                <select
                  id="AgeList"
                  v-model="AgeRange"
                  class="rfp-rr-ratings-write-review-221-or"
                  name="AgeRange"
                >
                  <option value="">{{ dropDownSelectText }}</option>
                  <option v-for="x in howOldAreYouInputValue" :key="x" :value="x">{{ x }}</option>
                </select>
                <span
                  v-if="validation.firstError('AgeRange')"
                  class="rfp-rr-ratings-write-review-212-a-or Refapp-ratings-validation-error"
                >
                  {{ ageRangeFieldValidationMsg }}
                </span>
              </div>
            </div>
          </div>
          <div
            class="rfp-rr-ratings-write-review-222-or body-row quality"
            :class="{
              'label-hide-show': !showHowWouldYouRateThisQualityOfThisProduct,
            }"
          >
            <div
              class="rfp-rr-ratings-write-review-223-or body-row-left"
              :class="{ 'rfp-rr-rating-rtl-float-right': isRightToLeftActive }"
            >
              {{ labelHowWouldYouRateThisQualityOfThisProduct }}
            </div>
            <div class="rfp-rr-ratings-write-review-224-or body-row-right">
              <div class="rfp-rr-ratings-write-review-225-or stars">
                <div
                  class="rfp-rr-ratings-write-review-226-or star"
                  :class="{ 'rfp-rr-rating-rtl-float-right': isRightToLeftActive }"
                >
                  <vue-star-rating
                    :increment="starRatingIncrementValue"
                    :max-rating="starRatingMaxRatingValue"
                    :inactive-color="starRatingInactiveColor"
                    :active-color="starRatingActiveColor"
                    :star-size="starRatingStarSize"
                    :overall-rating="HowWouldYouRateThisQualityOfThisProduct"
                    :show-rating="false"
                    :rating="HowWouldYouRateThisQualityOfThisProduct"
                    @update:rating="HowWouldYouRateThisQualityOfThisProduct = $event"
                  >
                  </vue-star-rating>
                </div>
              </div>
              <div class="rfp-rr-ratings-write-review-227-or star-label">
                <div v-if="HowWouldYouRateThisQualityOfThisProduct === 1">
                  {{ howWouldYouRateThisQualityOfThisProductDesc.one }}
                </div>
                <div v-else-if="HowWouldYouRateThisQualityOfThisProduct === 2">
                  {{ howWouldYouRateThisQualityOfThisProductDesc.two }}
                </div>
                <div v-else-if="HowWouldYouRateThisQualityOfThisProduct === 3">
                  {{ howWouldYouRateThisQualityOfThisProductDesc.three }}
                </div>
                <div v-else-if="HowWouldYouRateThisQualityOfThisProduct === 4">
                  {{ howWouldYouRateThisQualityOfThisProductDesc.four }}
                </div>
                <div v-else-if="HowWouldYouRateThisQualityOfThisProduct === 5">
                  {{ howWouldYouRateThisQualityOfThisProductDesc.five }}
                </div>
                <div v-else>
                  {{ howWouldYouRateThisQualityOfThisProductDefault }}
                </div>
              </div>
              <span
                v-if="validation.firstError('HowWouldYouRateThisQualityOfThisProduct')"
                class="rfp-rr-ratings-write-review-194-or Refapp-ratings-validation-error"
              >
                {{ qualityOfThisProductFieldValidationMsg }}
              </span>
            </div>
          </div>
          <div
            class="rfp-rr-ratings-write-review-222-or body-row quality"
            :class="{ 'label-hide-show': !showLabelYesOrNoRadio }"
          >
            <div
              class="rfp-rr-ratings-write-review-223-or body-row-left"
              :class="{ 'rfp-rr-rating-rtl-float-right': isRightToLeftActive }"
            >
              {{ yesOrNoRadioButtonLabelText }}
            </div>
            <div class="rfp-rr-ratings-write-review-224-or body-row-right">
              <div class="rfp-rr-ratings-write-review-227-or star-label">
                <div style="width: 100px; display: flex">
                  <input v-model="yesOrNoRadioValue" type="radio" value="true" />{{
                    yesRadioButtonLabelText
                  }}
                </div>
              </div>
              <div class="rfp-rr-ratings-write-review-227-or star-label">
                <div style="width: 100px; display: flex">
                  <input v-model="yesOrNoRadioValue" type="radio" value="false" />{{
                    noRadioButtonLabelText
                  }}
                </div>
              </div>
              <span
                v-if="validation.firstError('yesOrNoRadioValue')"
                class="rfp-rr-ratings-write-review-194-or Refapp-ratings-validation-error"
              >
                {{ yesOrNoRadioButtonValidationMsg }}
              </span>
            </div>
          </div>
          <div
            class="rfp-rr-ratings-write-review-228-or body-row full-width"
            :class="{
              'label-hide-show': !showLabelWouldYouRecommendThisProductToFriend,
            }"
          >
            <div class="body-row-left">
              {{ labelWouldYouRecommendThisProductToFriend }}
            </div>
            <div class="rfp-rr-ratings-write-review-229-or body-row-right">
              <div class="rfp-rr-ratings-write-review-230-or recommend-slider">
                <vue-slider
                  id="custom-tooltip"
                  v-bind="rangeSliderConfig"
                  v-model="wouldYouRecommendMaybellineToFriend"
                  name="wouldYouRecommendMaybellineToFriend"
                  :recommend-to-friend-rating-scale="recommendToFriendRatingScale"
                ></vue-slider>
              </div>
              <span
                v-if="validation.firstError('wouldYouRecommendMaybellineToFriend')"
                class="rfp-rr-ratings-write-review-194-or Refapp-ratings-validation-error"
              >
                {{ recommendProductToFriendFieldValidationMsg }}
              </span>
            </div>
          </div>
          <div v-if="imageUpload.Active" class="body-row full-width">
            <rfp-ratings-upload-image
              :config="imageUpload.Config"
              :dictionary="imageUpload.ImageUploadDictionary"
            ></rfp-ratings-upload-image>
          </div>
          <div
            class="rfp-rr-ratings-write-review-231-or checkboxes body-row form-terms-use"
            :class="{
              'label-hide-show': !showLabelTermsOfUse,
              'rfp-rr-rating-rtl-float-right': isRightToLeftActive,
            }"
          >
            <label
              class="rfp-rr-ratings-write-review-232-or mobile-terms"
              :class="{ 'rfp-rr-rating-rtl-float-right': isRightToLeftActive }"
            >
              <input
                v-model="termsOfUse"
                type="checkbox"
                class="rfp-rr-ratings-write-review-233-or checkbox--rr-design"
                :class="{ 'rfp-rr-rating-rtl-right': isRightToLeftActive }"
              />
              <span
                style="font-weight: 100"
                :class="{
                  error__text__red: validation.firstError('termsOfUse'),
                  'rfp-rr-rating-rtl-write-review-tearms': isRightToLeftActive,
                }"
                v-html="labelTermsOfUseStepOne"
              ></span>
            </label>
          </div>
          <div class="rfp-rr-ratings-write-review-234-or body-row action-row">
            <input
              type="submit"
              :value="reviewButtonText"
              class="button button-primary"
              :class="{ 'rfp-rr-rating-rtl-float-left': isRightToLeftActive }"
              text="Write"
            />
          </div>
        </div>
      </div>
    </form>
  </div>
</div>
